import { render, staticRenderFns } from "./DeliveryBase.vue?vue&type=template&id=77ee301a&scoped=true"
import script from "./DeliveryBase.vue?vue&type=script&lang=ts"
export * from "./DeliveryBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ee301a",
  null
  
)

export default component.exports